import { jsx as _jsx } from "react/jsx-runtime";
import ContentBox from "../../ContentBox";
import { GeneralInformation as GeneralInformationComponent } from "@ploy-ui/general-info";
const GeneralInformation = props => {
    const { boxProps } = props;
    return (_jsx(ContentBox, { ...boxProps, children: _jsx(GeneralInformationComponent, {}) }));
};
GeneralInformation.displayName = "DployDashboardGeneralInformation";
export default GeneralInformation;
//# sourceMappingURL=GeneralInformation.js.map